export const UPDATE_PAGINATION = "UPDATE_PAGINATION";

export const updatePagination = (value) => ({
  type: UPDATE_PAGINATION,
  value,
});
